import { useEffect } from "react";

interface FaqItem {
  q: string;
  a: string;
}

interface FaqJsonLdProps {
  items: FaqItem[];
}

const FaqJsonLd = ({ items }: FaqJsonLdProps) => {
  useEffect(() => {
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-faq-jsonld", "true");
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [items]);

  return null;
};

export default FaqJsonLd;
